<template>
  <div id="Data">
  <ul>

    <li class="listGrid">
      <p>Type : </p>
      <select v-model="Type">
        <option value="activities">Activities</option>
        <option value="projects">Projects</option> 
        <option value="education">Education</option>  
      </select>
    </li>

    <li class="listGrid"><p>ID : </p><input type="number" name="ID" placeholder="ID" v-model="ID"/></li>
    <li class="listGrid"><p>Name : </p><input type="text" name="Name" placeholder="Name" v-model="Name"/></li>
    <li class="listGrid"><p>Year : </p><input type="text" name="Year" placeholder="Year" v-model="Year"/></li>
    <li class="listGrid"><p>Month : </p><input type="text" name="Month" placeholder="Month" v-model="Month"/></li>
    <li class="listGrid"><p>Info : </p><textarea rows="4" cols="50" name="Info" placeholder="Info" v-model="Info"/></li>

    <li class="listGrid"> <p>Upload Image(s) : </p>
      <input type='file' name='img' @change="updateToUpload($event)" multiple>
    </li>

    <li>
      <div v-if="showSlider" :key="images" class="imageGallery">
      <carousel :center=false :nav=false :item=3 :margin=10 :dots=true :dotsEach=true>
        <div v-for="(image,index) in images" :key="index" class="middle">
          <img :src=images[index]>
          <button v-on:click="DeleteImage(path[index])" class="deleteButton">Delete</button>
        </div>
      </carousel>
      </div>
    </li>

    <div class="actionButtons">
    <li><button type="button" class="resetButton" v-on:click="resetData()">RESET</button></li>
    <li><button type="button" class="submitButton" v-on:click="verifyInput()">SUBMIT</button></li>
    </div>
  </ul>

  </div>
</template>

<script>
import axios from "axios";
import {store} from "../store.js";
import carousel from 'vue-owl-carousel';

export default {
  components: {carousel},
  data() {
    return {
      MAIN_ID:null,
      Type:null,
      ID: null,
      Name: null,
      Year: null,
      Month: null,
      Info:null,
      fullInfo:{},
      showSlider:false,
      images: null,
      toUpload:null,
      path:null
    };
  },
  methods: {
    submitData() {
        const formData = new FormData();
        formData.append("IsNew", store.getIsNew());
        formData.append("MAIN_ID", this.MAIN_ID);
        formData.append("Type", this.Type);
        formData.append("ID", this.ID);
        formData.append("Name", this.Name);
        formData.append("Year", this.Year);
        formData.append("Month", this.Month);
        formData.append("Info", this.Info);
        if(this.toUpload!=null){
            for(var i = 0; i < this.toUpload.length; i++){
                formData.append('images[]', this.toUpload[i], this.toUpload[i].name);
                // console.log(this.toUpload[i].size)
            }
        }
        var filesize = 0; 
        var res = Array.from(formData.entries(), ([key, prop]) => ({"ContentLength": typeof prop === "string" ? prop.length : prop.size }));

        Object.keys(res).forEach(function(key){
          filesize+=res[key].ContentLength;
        })

        if(filesize>8000000){
          alert("FILE TOOO BIG !");
        }
        else{
          axios
            .post(store.getphpPath() + "InsertDBtry.php", formData)
            .then(response => {
              console.log(response.data);
              alert("Submitted")
              this.getImages();
            })
            .catch(error => {
              console.log(error);
            });
        }
    },
    getImages: function() {
      axios
        .get(store.getphpPath() + "getImagesDBtry.php", {
          params: {
            table: store.getRowData().Type,
            rowID: store.getRowData().ID
          }
        })
        .then(response => {
          this.images = response.data[0];
          this.path = response.data[1];
          if(response.data[0].length>0){
            this.showSlider = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    DeleteImage(ImagePath){
      if (confirm('Are you really really sure you want to remove this image?')){
        const formData = new FormData();
        formData.append("Image_Path", ImagePath);
        axios
          .post(store.getphpPath() + "deleteImage.php", formData)
          .then(response => {
            // console.log(response.data);
            this.getImages();
          })
          .catch(error => {
            console.log(error);
          });
       }
    },
    updateToUpload(event){
      this.toUpload = event.target.files;
      // console.log(this.toUpload);
    },
    fillData(){
        this.fullInfo = store.getRowData();
        this.MAIN_ID = this.fullInfo.MAIN_ID;
        this.Type = this.fullInfo.Type;
        this.ID = this.fullInfo.ID;
        this.Name = this.fullInfo.Name;
        this.Year = this.fullInfo.Year;
        this.Month = this.fullInfo.Month;
        this.Info = this.fullInfo.Info;
        this.getImages();
    },
    resetData(){
      this.Type = null;
      this.ID = null;
      this.Name = null;
      this.Year = null;
      this.Month = null;
      this.Info = null;
      this.fullInfo={};
      this.images = null;
      this.showSlider = false;
    },
    verifyInput(){
      if( this.Type!=null &&
          this.ID!=null &&
          this.Name!=null &&
          this.Year!=null &&
          this.Month!=null &&
          this.Info!=null){
                this.submitData();
          }
        else{
          alert("No Empty Input")
        }

    }
  },created() {
    this.resetData();
      if(store.getIsNew()==false){
        this.fillData();
      }
  }
};
</script>
<style scoped>
input, select, textarea,option{
  color: black;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    border: none;
    max-width: 500px;
}

input[type="file"]{
  font-family: 'Courier New', Courier, monospace;
  color: white;
}

.listGrid{
  display: -ms-grid;
  display: grid;
  -ms-grid-columns:1.5fr 1em 3.5fr;
  grid-template-columns:1.5fr 3.5fr;
  grid-gap: 1em;;
  margin-bottom: 0.5em;
}

.listGrid p{
  font-family: 'Courier New', Courier, monospace;
  text-align: right;
  margin: 0;
}

.deleteButton{
  margin-top: 1em;
  width: 100%;
  text-align: center;
}

.deleteButton:hover{
  background: red;
  color: white;
}

.middle{
    display: -ms-grid;
    display: grid;
  -ms-grid-columns:1fr;
  grid-template-columns:1fr;

}

.imageGallery{
  margin-top:2em;
}

.actionButtons{
      display: -ms-grid;
      display: grid;
      -ms-grid-columns:1fr 1fr;
      grid-template-columns:1fr 1fr;
      margin-top: 1.5em;

}

.resetButton,.submitButton{
  width: 100%;
  text-align: center;
  height: 30px;
}
</style>
